<div class="preview-quote-container">
  <div class="dialog-header">
    <div>
      <div class="dialog-header-title">Cotação</div>
      <div class="dialog-header-subtitle">{{ quote.name }}</div>
      <div class="dialog-header-date" *ngIf="quote.createdAt">
        Enviado em {{ quote.createdAt | date: "dd/MM/yyyy 'às' HH:mm" }}
      </div>
    </div>
    <div class="header-actions">
      <!-- Botão Orçar: só aparece se não tem proposta vinculada -->
      <button *ngIf="!quote.proposal" class="btn btn-blue orcar-btn" (click)="orcar()" [disabled]="loadingOrcar">
        <mat-icon *ngIf="!loadingOrcar" class="s-18 mr-8">request_quote</mat-icon>
        <mat-spinner *ngIf="loadingOrcar" diameter="18"></mat-spinner>
        <span>Orçar</span>
      </button>
      <!-- Botão Ver Orçamento: aparece se tem proposta vinculada -->
      <button *ngIf="quote.proposal" 
        class="btn btn-blue orcar-btn" 
        [routerLink]="['/propostas', quote.proposal.token]" 
        (click)="dialogRef.close()"
        [matTooltip]="'#' + quote.proposal.proposalNumber + ' - ' + quote.proposal.shortDescription"
        matTooltipPosition="below">
        <mat-icon class="s-18 mr-8">description</mat-icon>
        <span>Ver Orçamento</span>
      </button>
      <div (click)="dialogRef.close()" class="close-btn" aria-label="Fechar">
        <mat-icon>close</mat-icon>
      </div>
    </div>
  </div>

  <mat-tab-group class="quote-tabs" animationDuration="200ms">
    <mat-tab label="Dados Gerais">
      <div class="tab-content">
        <div class="quote-section">
          <div class="section-title">Dados do cotador</div>

          <div class="quote-client-grid">
            <div class="field">
              <div class="label">Email</div>
              <div class="value">{{ quote.email }}</div>
            </div>
            <div class="field">
              <div class="label">Telefone</div>
              <div class="value">{{ quote.phone }}</div>
            </div>
            <div class="field">
              <div class="label">CEP</div>
              <div class="value">{{ quote.cep }}</div>
            </div>
            <div class="field">
              <div class="label">Origem</div>
              <div class="value">{{ quote.origin || 'Link Padrão' }}</div>
            </div>
            <div class="field full">
              <div class="label">Endereço</div>
              <div class="value">
                {{ quote.address }}
                <span *ngIf="quote.addressNumber">, {{ quote.addressNumber }}</span>
                <span *ngIf="quote.addressComplement"> - {{ quote.addressComplement }}</span>
              </div>
            </div>
            <div class="field">
              <div class="label">Bairro</div>
              <div class="value">{{ quote.neighborhood }}</div>
            </div>
            <div class="field">
              <div class="label">Cidade</div>
              <div class="value">{{ quote.city }}</div>
            </div>
            <div class="field">
              <div class="label">Estado</div>
              <div class="value">{{ quote.state }}</div>
            </div>
          </div>
        </div>

        <div class="quote-section" *ngIf="quote.description">
          <div class="section-title">Observações do cliente</div>
          <div class="quote-notes">{{ quote.description }}</div>
        </div>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        Itens <span class="tab-badge">{{ (quote.items || []).length }}</span>
      </ng-template>
      <div class="tab-content">
        <div class="quote-items-scroll">
          <table class="quote-items-table">
            <thead>
              <tr>
                <th>Item</th>
                <th class="qty">Quantidade</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of (quote.items || [])">
                <td class="item">
                  <div class="item-main">
                    <span class="item-name">{{ item.name }}</span>
                  </div>
                  <div class="item-extra" *ngIf="item.product?.code || item.product?.valor != null || item.unit?.abbr || item.product?.unit?.abbr">
                    <span *ngIf="item.product?.code">#{{ item.product.code }}</span>
                    <span *ngIf="item.product?.valor != null">
                      <ng-container *ngIf="item.product?.code"> | </ng-container>
                      {{ item.product.valor | currency:'BRL' }}
                    </span>
                    <span *ngIf="item.unit?.abbr || item.product?.unit?.abbr">
                      <ng-container *ngIf="item.product?.code || item.product?.valor != null"> | </ng-container>
                      {{ item.unit?.abbr || item.product?.unit?.abbr }}
                    </span>
                  </div>
                </td>
                <td class="qty">
                  {{ item.quantity }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
